/**
 * Contribution roles taxonomy — generated from taxonomy_updated.csv.
 * To regenerate: node admin_portal/src/data/generate-contributions-taxonomy.js
 */

/** All unique contribution roles (parent + child), sorted alphabetically. */
export const allContributionRoles: string[] = [
  "12 string guitar",
  "12-string acoustic guitar",
  "12-string bass",
  "12-string guitar",
  "17-string bass koto",
  "5-string banjo",
  "6-string banjo",
  "6-string bass",
  "8-string bass guitar",
  "a&r",
  "abridged by",
  "accompanied by",
  "accompanist",
  "accordina",
  "accordion",
  "achere",
  "acoustic bass",
  "acoustic bass guitar",
  "acoustic fretless guitar",
  "acoustic guitar",
  "acoustic piano",
  "acoustic piccolo bass",
  "actor",
  "adapted by",
  "adapted by (text)",
  "administrator",
  "adufe",
  "adungu",
  "advisor",
  "aeolian harp",
  "afoxe",
  "african congo drums",
  "afuche",
  "agogo",
  "ajaeng",
  "akete",
  "aketse",
  "akkordolia",
  "alfaia",
  "algaita",
  "algerian mandole",
  "alghoza",
  "algoja",
  "algoza",
  "alp horn",
  "alphorn",
  "alto",
  "alto (voice)",
  "alto clarinet",
  "alto crumhorn",
  "alto flute",
  "alto horn",
  "alto recorder",
  "alto saxophone",
  "alto trombone",
  "alto valve trombone",
  "alto viol",
  "alto violin",
  "alto vocals",
  "amadinda",
  "aman khuur",
  "ambtara",
  "analog synthesizer",
  "anandalahari",
  "anatara",
  "andean flute",
  "andean harp",
  "angklung",
  "anglo concertina",
  "anglo-concertina",
  "animal sounds",
  "animal sounds impersonator",
  "animation",
  "ankle rattlers",
  "announcer",
  "antara",
  "anvil",
  "apentemma",
  "apito",
  "apongalahy",
  "appalachian dulcimer",
  "archilute",
  "archlute",
  "archtop guitar",
  "arco bass",
  "arghul",
  "arpa",
  "arpeggione",
  "arrabel",
  "arranged by",
  "arranger",
  "art direction",
  "art proverb",
  "artist",
  "artist (unidentified)",
  "artistic narrative narrator",
  "artistic narrator",
  "artistic producer",
  "artwork",
  "artwork by",
  "ashiko",
  "asiko",
  "assemblage",
  "associate producer",
  "atabal",
  "atabaque",
  "atarigane",
  "atchere",
  "audio generator",
  "author",
  "authoring",
  "autoharp",
  "automatic orchestra",
  "baandu",
  "baby grand piano",
  "background studio singer",
  "backing band",
  "backing vocals",
  "baglama",
  "baglama (saz) family",
  "baglamas",
  "bagpipe",
  "bagpipes",
  "bahian guitar",
  "bajo",
  "bajo quinto",
  "bajo sexto",
  "balafon",
  "balalaika",
  "baltic psalteries",
  "bambaro",
  "bamboo flute",
  "band",
  "bandola",
  "bandolin",
  "bandoneon",
  "bandoneon concertina",
  "bandora",
  "bandura",
  "bandurria",
  "bangu",
  "banhu",
  "banjitar",
  "banjo",
  "banjo guitar",
  "banjo-dulcimer",
  "banjo-mandolin",
  "banjo-ukulele",
  "banjolin",
  "banjulele",
  "bankia",
  "bansuri",
  "bansuri flute",
  "bapang",
  "bara",
  "barbat",
  "baritone",
  "baritone (saxhorn)",
  "baritone (voice)",
  "baritone clarinet",
  "baritone guitar",
  "baritone horn",
  "baritone saxhorn",
  "baritone saxophone",
  "baritone violin",
  "baritone vocals",
  "baroque guitar",
  "baroque trumpet",
  "barrel drum",
  "barrel organ",
  "barrel piano",
  "barrel-organ",
  "baryton",
  "bass",
  "bass (vocal)",
  "bass (voice)",
  "bass accordion",
  "bass clarinet",
  "bass concertina",
  "bass crumhorn",
  "bass drum",
  "bass dulcian",
  "bass e",
  "bass fado viola",
  "bass flute",
  "bass guitar",
  "bass harmonica",
  "bass lute",
  "bass marimba",
  "bass oboe",
  "bass pedals",
  "bass rackett",
  "bass recorder",
  "bass saxophone",
  "bass synthesizer",
  "bass tambura",
  "bass trombone",
  "bass trumpet",
  "bass tuba",
  "bass viol",
  "bass violin",
  "bass vocals",
  "bass-baritone",
  "bass-baritone (voice)",
  "bass-baritone vocals",
  "basset clarinet",
  "basset horn",
  "basso continuo",
  "bassoon",
  "basy",
  "bata",
  "bata drum",
  "bawu",
  "bayan",
  "bazooka",
  "beat box",
  "beat box (vocal)",
  "beatbox",
  "beats",
  "bedug",
  "bell",
  "bell plate",
  "bell tree",
  "bell-piano",
  "bellow-blown bagpipes",
  "bellowed reed",
  "bellowphone",
  "bells",
  "bembe",
  "bendir",
  "berda",
  "beresta",
  "berimbau",
  "bhapang",
  "bicycle bell",
  "big drum",
  "bin",
  "bin-sasara",
  "bin-sitar",
  "biniou",
  "birbyne",
  "birch lur",
  "bisernica",
  "biwa",
  "blaster beam",
  "blue harp",
  "blues harp",
  "bo (bell)",
  "bo (cymbals)",
  "bo (flute)",
  "boatswain's pipe",
  "bodhran",
  "body percussion",
  "bolivian flute",
  "bolon",
  "bombarde",
  "bombardon",
  "bombo",
  "bombo (bass drum)",
  "bombo (frame drum)",
  "bombo (mouth bom)",
  "bombo leguero",
  "bonang",
  "bonang barung",
  "bonang panembung",
  "bonang panerus",
  "bones",
  "bongo",
  "bongos",
  "boobam",
  "boobams",
  "booking",
  "booklet editor",
  "boomwhacker",
  "border pipes",
  "bordonua",
  "bottle",
  "bouzar",
  "bouzouki",
  "bowed lute",
  "bowed lyre",
  "bowed piano",
  "bowed psaltery",
  "bowed string instruments",
  "box zither",
  "brac",
  "braguinha",
  "brass",
  "brass band",
  "brass bass",
  "bronze lur",
  "broom",
  "brushes",
  "bucium",
  "bugarija",
  "bugle",
  "bugle(-horn)",
  "buhay",
  "buisine",
  "buk",
  "bukkehorn",
  "bulbul tarang",
  "bull fiddle",
  "bullroarer",
  "button accordion",
  "buzuq",
  "byzaanchi",
  "c melody saxophone",
  "c-bass recorder",
  "c-melody saxophone",
  "cabasa",
  "cadenza",
  "caixa",
  "caja",
  "caja vallenata",
  "cajas rumberas",
  "cajon",
  "cajon peruano",
  "calabash",
  "caller",
  "calligraphy",
  "calliope",
  "calung",
  "cameraman",
  "campana",
  "cantor",
  "caramusa",
  "carillon",
  "carnyx",
  "castanets",
  "castrato",
  "castrato (voice)",
  "cavaco",
  "cavaquinho",
  "caxixi",
  "celesta",
  "celeste",
  "cello",
  "cello banjo",
  "celo",
  "cembalet",
  "ceng ceng",
  "cetara",
  "cevgen",
  "cgi artist",
  "chacaras",
  "chacha",
  "chak'chas",
  "chakhe",
  "chalumeau",
  "chamber organ",
  "chamber pipes",
  "chamberlin",
  "chande",
  "changgo",
  "changi",
  "chansonnier",
  "chanter",
  "chanting",
  "chanzy",
  "chap",
  "chap lek",
  "chapman",
  "chapman stick",
  "charamel",
  "charango",
  "chasquidos",
  "chau gong",
  "chekere",
  "cheng",
  "chikuzen biwa",
  "chime bar",
  "chimes",
  "chinchin",
  "chinese drum",
  "chinese flute",
  "chinese harp",
  "ching",
  "ching (cymbals)",
  "chirimia",
  "chirimia and drum",
  "chitarra battente",
  "chitarrone",
  "chitra veena",
  "chiwata",
  "chocalho",
  "choir",
  "choir member",
  "choir singer",
  "choir singing",
  "choir stand-in",
  "chonguri",
  "choral conductor",
  "choreography",
  "chorus",
  "chorus master",
  "chromatic button accordion",
  "chromatic harmonica",
  "chuniri",
  "church organ",
  "chuurqin",
  "cifteli",
  "cigar box guitar",
  "cimbalom",
  "cimbasso",
  "cimpoi",
  "cinema organ",
  "cinematographer",
  "cither",
  "citole",
  "cittern",
  "cizhonghu",
  "clap",
  "clap sticks",
  "clapper",
  "clappers",
  "clapping",
  "clapstick",
  "clarin cajamarquino",
  "clarinet",
  "clarinet (c)",
  "clarinet (e flat)",
  "clarion",
  "clarsach",
  "classic guitar",
  "classical guitar",
  "classical kemence",
  "claves",
  "clavichord",
  "clavier",
  "clavinet",
  "claviola",
  "clavioline",
  "claviorgan",
  "claviorganum",
  "clog",
  "clog dancer",
  "co",
  "co ke",
  "co-producer",
  "cobza",
  "colascione",
  "collected by",
  "comb",
  "combolin",
  "comedian",
  "commentator",
  "commissioned by",
  "compilation producer",
  "compiled by",
  "composed by",
  "composer",
  "computer",
  "concept",
  "concept by",
  "concert band",
  "concert flute",
  "concert grand piano",
  "concert harp",
  "concertina",
  "concertmaster",
  "concertmistress",
  "conch",
  "conch shell",
  "concussion idiophone",
  "conductor",
  "conductor (instruments)",
  "conductor (strings)",
  "conductor (vocals)",
  "conga",
  "congas",
  "consultant",
  "continuum",
  "contra-alto clarinet",
  "contrabass",
  "contrabass clarinet",
  "contrabass flute",
  "contrabass recorder",
  "contrabass saxophone",
  "contrabass trombone",
  "contrabass violin",
  "contrabassoon",
  "contractor",
  "contralto",
  "contralto (voice)",
  "contralto vocals",
  "contribution",
  "coordinator",
  "copyist",
  "cor anglais",
  "cornamuse",
  "cornet",
  "cornett",
  "corno da caccia",
  "coro",
  "costume designer",
  "counter tenor",
  "counter-tenor",
  "counter-tenor (voice)",
  "countertenor",
  "countertenor vocals",
  "cover",
  "cover art concept",
  "cover design",
  "cowbell",
  "cowbells",
  "crash cymbals",
  "craviola",
  "created by",
  "creative director",
  "cretan lyra",
  "crew",
  "cristal baschet",
  "cromorne",
  "crotales",
  "crumhorn",
  "crwth",
  "cuatro",
  "cuica",
  "cultrun",
  "cumbus",
  "cura",
  "curated by",
  "curch organ",
  "curtal",
  "cyla-diare",
  "cylindrical drum",
  "cymbal",
  "cymbals",
  "daegeum",
  "daf",
  "daire",
  "daluo",
  "damaru",
  "dan bau",
  "dan nguyet",
  "dan nhi",
  "dan tam",
  "dan tam thap luc",
  "dan tranh",
  "dan tu",
  "dan tu day",
  "dan ty ba",
  "danburo",
  "dance",
  "dancer",
  "dancer saw",
  "danso",
  "darabuka",
  "darabukka",
  "darbuka",
  "daruan",
  "davul",
  "daw",
  "daxaphone",
  "deaejeng",
  "denis d'or",
  "design",
  "design concept",
  "dhol",
  "dholak",
  "di (flute)",
  "di (slit drum)",
  "diaff",
  "dialog",
  "diatonic button accordion",
  "diddley bow",
  "didgeridoo",
  "didjeridu",
  "digital audio workstation",
  "dikanza",
  "dili tuiduk",
  "dilli tuiduk",
  "dilruba",
  "ding buot",
  "ding nam",
  "ding tac ta",
  "diple",
  "directed by",
  "director of photography",
  "disk drive",
  "diyingehu",
  "dizi",
  "dj",
  "dj (mixer)",
  "dj (scratcher)",
  "dj (spoken word)",
  "dj (toaster)",
  "dj mix",
  "djembe",
  "djoza",
  "djura",
  "dobro",
  "dobro-bass",
  "dohol",
  "doira",
  "dojo",
  "dolceola",
  "doli",
  "dombra",
  "domra",
  "doneli",
  "donno",
  "donso ngoni",
  "doorbell",
  "doshpuluur",
  "dotara",
  "double bass",
  "double bassoon",
  "double clarinet",
  "double fluite",
  "double flute",
  "double reed",
  "doumbaki",
  "doumbi",
  "doyra",
  "dramyin",
  "dril-bu",
  "droma",
  "drone",
  "drum kit",
  "drum machine",
  "drum major",
  "drum programming",
  "drum sergeant",
  "drumkit",
  "drums",
  "drums (drum set)",
  "duck call",
  "duduk",
  "duet with",
  "duff",
  "duggi",
  "dulce melos",
  "dulceola",
  "dulcian",
  "dulcimer",
  "dulcitone",
  "dulzaina",
  "dumbak",
  "dumbelek",
  "dumbuks",
  "dundun",
  "dung-chen",
  "dunun",
  "dutar",
  "duxianqin",
  "dvojacka",
  "dvojnice",
  "e-bass",
  "e-bow",
  "e-flat clarinet",
  "e-guitar",
  "e-organ",
  "ebow",
  "edited by",
  "editor",
  "ektar",
  "ektara",
  "ektare",
  "electric accordion",
  "electric appalachian dulcimer",
  "electric baritone guitar",
  "electric bass",
  "electric bass guitar",
  "electric cello",
  "electric drums",
  "electric fiddle",
  "electric fretless guitar",
  "electric grand piano",
  "electric guitar",
  "electric harmonium",
  "electric harp",
  "electric harpsichord",
  "electric keyboards",
  "electric lap steel guitar",
  "electric mandolin",
  "electric organ",
  "electric piano",
  "electric sitar",
  "electric upright bass",
  "electric viola",
  "electric violin",
  "electronic cello",
  "electronic drum kit",
  "electronic drum set",
  "electronic drums",
  "electronic instrument",
  "electronic music",
  "electronic organ",
  "electronic percussion",
  "electronic piano",
  "electronic valve instrument",
  "electronic vibraphone",
  "electronic violin",
  "electronic wind instrument",
  "electronics",
  "electronium",
  "elektronium",
  "eligible studio producer",
  "emulator",
  "end-blown flute",
  "engineer",
  "engineered by",
  "english bagpipes",
  "english concertina",
  "english flageolet",
  "english guitar",
  "english horn",
  "ensemble",
  "entertainer",
  "epinette des vosges",
  "erhu",
  "esraj",
  "euphonium",
  "ewi",
  "executive producer",
  "executive remaster producer",
  "executive-producer",
  "ezzo-soprano",
  "fado viola",
  "fairground organ",
  "falsetto",
  "falsetto (voice)",
  "falsetto vocals",
  "fanfare trumpet",
  "fanfaretrumpet",
  "farfisa",
  "featuring",
  "feedback",
  "fiddle",
  "field recording",
  "fife",
  "film director",
  "film editor",
  "film producer",
  "film technician",
  "filmed by",
  "finger clicks",
  "finger cymbals",
  "finger snaps",
  "fipple flute",
  "five string banjo",
  "five-string banjo",
  "flabiol",
  "flageolet",
  "flamenco guitar",
  "flauta",
  "flexatone",
  "floppy disk drive",
  "floyera",
  "flugabone",
  "flugelhorn",
  "fluier",
  "flumpet",
  "flute",
  "flute d'amour",
  "flute organ",
  "flutina",
  "folk guitar",
  "folk harp",
  "folklorist",
  "foot stamping",
  "foot stomps",
  "foot tapping",
  "footbass",
  "fortepiano",
  "fotdella",
  "four-string banjo",
  "frame drum",
  "free reed",
  "free-reed flute",
  "french bagpipes",
  "french horn",
  "fretless bass",
  "fretless bass guitar",
  "fretless guitar",
  "friction drum",
  "friction idiophone",
  "frigideira",
  "friscaletto",
  "frottoir",
  "frying-pan",
  "fujara",
  "fundeh",
  "fyell",
  "gadulka",
  "gaffer",
  "gaita",
  "gajde",
  "galician gaita",
  "gallichon",
  "galo",
  "galoubet",
  "gambang",
  "game console sound chip",
  "gamelan",
  "ganga",
  "gangsa",
  "gankogui",
  "ganza",
  "gaohu",
  "gardon",
  "garifuna drum",
  "garklein recorder",
  "garmon",
  "gayageum",
  "gbedu",
  "gehu",
  "gemshorn",
  "gender",
  "gender barung",
  "gender panerus",
  "gender wayang",
  "genggong",
  "geomungo",
  "german concertina",
  "german harp",
  "ghara",
  "ghatam",
  "ghati",
  "ghayta",
  "ghijak",
  "ghungroo",
  "giga",
  "gimbri",
  "gini",
  "gittern",
  "glass",
  "glass harmonica",
  "glass harp",
  "glockenspiel",
  "goblet drum",
  "goge",
  "goje",
  "gong",
  "gong bass drum",
  "gong chime",
  "gong-chime",
  "gorodao",
  "gottuvadyam",
  "gourd",
  "gourd rattle",
  "gourds",
  "gralla",
  "gramorimba",
  "grand piano",
  "grantang",
  "graphic design",
  "graphics",
  "gravikord",
  "great bass recorder",
  "great highland bagpipe",
  "griot",
  "grip",
  "grneta",
  "groovebox",
  "gu",
  "gua'chara",
  "guacharaca",
  "guan",
  "guayo",
  "guban",
  "gubgubi",
  "gudastviri",
  "gudok",
  "gudugudu",
  "guest",
  "guimbri",
  "guira",
  "guiro",
  "guitalele",
  "guitar",
  "guitar synthesizer",
  "guitaret",
  "guitarra",
  "guitarron",
  "guitarron chileno",
  "guitarron mexicano",
  "guitarviol",
  "guitolao",
  "guitorgan",
  "guitsteel",
  "gumbri",
  "gunbri",
  "gung",
  "guntang",
  "guqin",
  "gusli",
  "guzheng",
  "haegeum",
  "haegum",
  "hair",
  "halldorophone",
  "halszither",
  "hammer",
  "hammered dulcimer",
  "hammond organ",
  "hammond-organ",
  "hand bells",
  "hand clapping",
  "handbell",
  "handclapping",
  "handclaps",
  "handpan",
  "hang drum",
  "hard disk drive",
  "hardanger fiddle",
  "hardangerfiddle",
  "hardingfele",
  "harjedalspipa",
  "harmet",
  "harmonica",
  "harmonium",
  "harmony vocals",
  "harp",
  "harp guitar",
  "harpejji",
  "harpsichord",
  "harpsipiano",
  "haute-contre",
  "haute-contre (voice)",
  "haute-contre vocals",
  "hawaii guitar",
  "hawaiian guitar",
  "heckelphone",
  "heike biwa",
  "helico",
  "helicon",
  "hi-hat",
  "hichiriki",
  "high violin",
  "highland bagpipes",
  "highland pipes",
  "hihat",
  "hmong flute",
  "hoddu",
  "homus",
  "horagai",
  "horn",
  "horns",
  "hosho",
  "hoshu",
  "hosted by",
  "hot fountain pen",
  "hotchiku",
  "hourglass drum",
  "huapanguera",
  "hudukka",
  "hue puruhau",
  "hue puruwai",
  "hulusi",
  "human beatbox",
  "hummel",
  "humming",
  "hunting horn",
  "hunting horn (valved)",
  "huqin",
  "hurdy gurdy",
  "hurdy-gurdy",
  "hyoshigi",
  "ichigenkin",
  "idiophone",
  "igil",
  "illustration",
  "image editor",
  "imitation bass",
  "impersonator",
  "indian harp",
  "indonesian rebab",
  "instr",
  "instructor",
  "instrument",
  "instrumentation by",
  "instruments",
  "interview",
  "interviewee",
  "interviewer",
  "irish bouzouki",
  "irish flute",
  "irish harp",
  "irish whistle",
  "jagd horn",
  "jaggo",
  "jal tarang",
  "janggu",
  "jantar",
  "japanese wooden flute",
  "jarana",
  "jazz horn",
  "jazz-horn",
  "jegogan",
  "jejo",
  "jejo voatavo",
  "jeli ngoni",
  "jew's harp",
  "jews harp",
  "jing",
  "jing'erhu",
  "jinghu",
  "jingle bells",
  "joik",
  "jouhikko",
  "jublag",
  "jug",
  "jugkalimba",
  "jumbush",
  "junjung",
  "jushichigen-kin (bass koto)",
  "k'kwaengwari",
  "ka (drum)",
  "kaba gaida",
  "kabosa",
  "kabosy",
  "kacapi",
  "kacapi indung",
  "kacapi rincik",
  "kacapi siter",
  "kachva sitar",
  "kagura suzu",
  "kagurabue",
  "kaiamba rambo",
  "kakegoe",
  "kalimba",
  "kamac",
  "kamaica",
  "kamale ngoni",
  "kamancha",
  "kamanche",
  "kamancheh",
  "kanjira",
  "kankles",
  "kannel",
  "kantele",
  "kantilan",
  "kanun",
  "karamouza",
  "karigo",
  "karkabas",
  "karna",
  "karna (trumpet)",
  "kartal",
  "kaval",
  "kayagum",
  "kazoo",
  "kecer",
  "kemanak",
  "kemence",
  "kemence of the black sea",
  "kemenche",
  "kemene",
  "kempli",
  "kempul",
  "kempur",
  "kempyang",
  "ken bau",
  "ken la",
  "kena",
  "kendang",
  "kendang lanang",
  "kendang wadon",
  "kendhang batangan",
  "kendhang gendhing",
  "kendhang indung",
  "kendhang ketipung",
  "kendhang kulanter",
  "kendhang wayangan",
  "kenong",
  "kepyak",
  "kethuk",
  "kettle drum",
  "kettledrum",
  "ketuk",
  "keyboard bass",
  "keyboards",
  "keyed box zither",
  "keyed brass instruments",
  "keytar",
  "khaen",
  "khalam",
  "khartal",
  "khen meo",
  "khene",
  "khim",
  "khlui",
  "khol",
  "khong wong",
  "khong wong lek",
  "khong wong yai",
  "khulsan khuur",
  "khurdak",
  "khuur",
  "ki pah",
  "kinnor",
  "kirar",
  "kithara",
  "kkwaenggwari",
  "kkwaengwari",
  "klong",
  "klong khaek",
  "klong song na",
  "klong that",
  "klong yao",
  "koauau",
  "koauau ponga ihu",
  "kobyz",
  "kokle",
  "kokyu",
  "komun'go",
  "komuz",
  "kong wong yai",
  "kora",
  "kortholt",
  "kos",
  "koto",
  "kotsuzumi",
  "krakebs",
  "krap",
  "krap khu",
  "krap phuang",
  "krap sepha",
  "krar",
  "kudum",
  "kulintang",
  "kusle",
  "kynggari",
  "lacquer cut by",
  "lagerphone",
  "lakota flute",
  "lakoto flute",
  "lamba",
  "lamellaphone",
  "lamellophone",
  "langeleik",
  "laouto",
  "lap harp",
  "lap steel guitar",
  "laser harp",
  "lathe cut by",
  "laud",
  "launeddas",
  "lautenwerck",
  "lavta",
  "layout",
  "lead guitar",
  "lead vocal",
  "lead vocals",
  "leader",
  "leadvocals",
  "legal",
  "lettering",
  "libretto by",
  "lighting",
  "lighting director",
  "likembe",
  "lilting",
  "limbe",
  "liner notes",
  "lion's roar",
  "lira",
  "lira da braccio",
  "lira organizzatai",
  "lirica",
  "lirone",
  "liru",
  "literary director",
  "lithography",
  "lithophone",
  "liuqin",
  "llaute",
  "log drum",
  "lokanga bara",
  "lokole",
  "loops",
  "low whistle",
  "lowland pipes",
  "lukeme",
  "lur",
  "lute",
  "lute guitar",
  "lute harpsichord",
  "lute-harpsichord",
  "lutheal",
  "luthier",
  "lyra",
  "lyra viol",
  "lyre",
  "lyricon",
  "lyrics by",
  "lysarden",
  "madal",
  "maddalam",
  "maddale",
  "magruna",
  "make-up",
  "mallets",
  "management",
  "mandobass",
  "mandocello",
  "mandoguitar",
  "mandola",
  "mandolin",
  "mandolin banjo",
  "mandolin family",
  "mandolincello",
  "mandolute",
  "mandora",
  "mandore",
  "manjira",
  "manjur",
  "mankeri",
  "manzello",
  "maracas",
  "maraccas",
  "marimba",
  "marimba lumina",
  "marimbula",
  "marine trumpet",
  "mark tree",
  "marovany",
  "marxophone",
  "masenqo",
  "masinko",
  "master of ceremonies (mc)",
  "mastered by",
  "mbira",
  "mc",
  "mechanical general",
  "mejoranera",
  "mellophone",
  "mellophonium",
  "mellotron",
  "melodeon",
  "melodica",
  "melophone",
  "membranophone",
  "mendoza",
  "metallophone",
  "mexican vihuela",
  "mey",
  "mezzo violin",
  "mezzo-contralto",
  "mezzo-contralto (voice)",
  "mezzo-contralto vocals",
  "mezzo-soprano",
  "mezzo-soprano (voice)",
  "mezzo-soprano vocals",
  "mezzosoprano",
  "mezzosoprano (voice)",
  "midi",
  "midi controller",
  "midi instrument",
  "midistick",
  "mijwiz",
  "minimoog",
  "minipiano",
  "minister",
  "mirliton",
  "mirwas",
  "miscellaneous",
  "mixed by",
  "mixer",
  "mizmar",
  "mizwad",
  "moceno",
  "model",
  "mong",
  "monkey stick",
  "monochord",
  "moog",
  "morchang",
  "morin khuur",
  "morinhoor",
  "morrisette",
  "morsing",
  "mountain dulcimer",
  "mouth bow",
  "mouth harp",
  "mouth music",
  "mouth organ",
  "mrdanga",
  "mridangam",
  "mukkuri",
  "munnharpe",
  "murali",
  "murcang",
  "murli",
  "muselar",
  "musette",
  "musette de cour",
  "music box",
  "music by",
  "music consultant",
  "music director",
  "music librarian",
  "music sequencer",
  "music video clip director",
  "musical assistance",
  "musical bow",
  "musical box",
  "musical saw",
  "musician",
  "n'vike",
  "nabal",
  "nadaswaram",
  "nagadou-daiko",
  "nagak",
  "nai",
  "nakers",
  "nal",
  "nal (drum)",
  "nanga",
  "naobo",
  "naqareh",
  "naqqara",
  "narrator",
  "nattuva talam",
  "natural brass instruments",
  "natural horn",
  "natural trumpet",
  "ney",
  "ngoma",
  "ngomi",
  "ngoni",
  "nguru",
  "nigenkin",
  "njarka",
  "nkoni",
  "nohkan",
  "noises",
  "northumbrian pipes",
  "northumbrian small pipes",
  "nose flute",
  "nose whistle",
  "novachord",
  "nyatiti",
  "nyatitit",
  "nyckelharpa",
  "nycleharpe",
  "oboe",
  "oboe d'amore",
  "oboe da caccia",
  "oboe dacaccia",
  "oboe damore",
  "ocarina",
  "ocean drum",
  "octapad",
  "octave mandolin",
  "octavilla",
  "octavina",
  "octoban",
  "octobass",
  "okonkole",
  "oktawka",
  "olifant",
  "omnichord",
  "ondes martenot",
  "ondioline",
  "one-man band",
  "onoben",
  "open-back banjo",
  "ophicleide",
  "optigan",
  "orchestra",
  "orchestrated by",
  "orchestration",
  "orchestrator",
  "organ",
  "organistrum",
  "originally by",
  "orpharion",
  "orphica",
  "otamatone",
  "other",
  "other instruments",
  "other music video clip creator",
  "other plucking instruments",
  "other woodwind instruments",
  "otsuzumi",
  "oud",
  "outi",
  "oval spinet",
  "overdubbed by",
  "overtone flute",
  "overtone voice",
  "p'iri",
  "pahu",
  "pahu pounamu",
  "paiban",
  "pailas",
  "painting",
  "pakhavaj",
  "pakhawaj",
  "pakuru",
  "palmas",
  "pan flute",
  "pan(dean) pipes",
  "pandeiro",
  "pandereta",
  "panduri",
  "pang gu ly hu hmong",
  "pano",
  "panpipe",
  "panpipes",
  "paraguayan harp",
  "pardessus de viole",
  "pardessus deviole",
  "parlour grand piano",
  "pate",
  "pedabro",
  "pedal accordion",
  "pedal piano",
  "pedal steel guitar",
  "pedalboard",
  "pemade",
  "percussion",
  "percussion idiophone",
  "performer",
  "phach",
  "photography",
  "photography by",
  "pi",
  "pi chawa",
  "pi nai",
  "pi thiu",
  "pianet",
  "piano",
  "piano accordion",
  "piano duo",
  "piano four hands",
  "piano quartet",
  "piano spinet",
  "piano trio",
  "pianoforte",
  "piccolo",
  "piccolo banjo",
  "piccolo bass",
  "piccolo bass guitar",
  "piccolo flute",
  "piccolo oboe",
  "piccolo trumpet",
  "pierrot ensemble",
  "pifana",
  "piffaro",
  "pipa",
  "pipe",
  "pipe and tabor",
  "pipe major",
  "pipe organ",
  "pipe sergeant",
  "pipes",
  "piri",
  "pirula",
  "pito",
  "pito herreno",
  "pixiephone",
  "pkhachich",
  "plated by",
  "platillos",
  "player piano",
  "plectrum banjo",
  "plucked idiophone",
  "plucked string instruments",
  "pluriarc",
  "pocket trumpet",
  "poetry reader",
  "poi",
  "poi awhiowhio",
  "polyphon",
  "porotiti",
  "portative",
  "portuguese guitar",
  "porutu",
  "positive (organ)",
  "positive organ",
  "post horn",
  "post production",
  "post-horn",
  "practice chanter",
  "preacher",
  "prempensua",
  "prepared piano",
  "presenter",
  "primero",
  "producer",
  "producer (rhythm track)",
  "producer (vocal)",
  "producer remixer",
  "producer vocal",
  "product manager",
  "production manager",
  "programmed by",
  "programming",
  "project manager",
  "promotion",
  "proofreader",
  "psalmodicon",
  "psaltery",
  "public relations",
  "pujador",
  "pukaea",
  "pulankulai",
  "pulankulal",
  "pullankulal",
  "pumotomoto",
  "pump organ",
  "pupakapaka",
  "purerehua",
  "putatara",
  "putorino",
  "qanun",
  "qasaba",
  "qilaut",
  "qirba",
  "quadruple reed",
  "quart-bassoon",
  "quena",
  "quenacho",
  "quijada",
  "quills",
  "quint-bassoon",
  "quinto",
  "quinton",
  "quray",
  "rabab",
  "rababa",
  "rabeca",
  "rabel",
  "racket",
  "rackett",
  "raconteur",
  "rag dung",
  "rain stick",
  "rainstick",
  "rammana",
  "ranat ek",
  "ranat kaeo",
  "ranat thum",
  "rap",
  "rapper",
  "ratchet",
  "rattle",
  "rauschpfeife",
  "ravanahatha",
  "reactable",
  "read by",
  "realization",
  "rebab",
  "rebec",
  "reciter",
  "reco reco",
  "reco-reco",
  "recorded by",
  "recorder",
  "recording supervisor",
  "reed",
  "reed organ",
  "reeds",
  "regal",
  "rehu",
  "reikin",
  "reissue producer",
  "remaster producer",
  "remastered by",
  "remix",
  "remix engineer",
  "remixer",
  "renaissance rackett",
  "repeater",
  "repetiteur",
  "repicador",
  "repinique",
  "repique",
  "reporter",
  "requinto",
  "requinto guitar",
  "research",
  "resonator",
  "resonator banjo",
  "resonator guitar",
  "restoration",
  "reyong",
  "rgya-gling",
  "rhaita",
  "rhodes piano",
  "rhythm guitar",
  "rhythm section",
  "rhythm sticks",
  "rhythms box",
  "riq",
  "riqq",
  "rkang-gling",
  "rnga",
  "rol-mo",
  "rondador",
  "rondadores",
  "ronroco",
  "roria",
  "rototom",
  "rototoms",
  "rozhok",
  "ruan",
  "ruann",
  "rubab",
  "rubboard",
  "rudra veena",
  "rudravina",
  "ryuteki",
  "sabar",
  "sabaro",
  "sackbut",
  "sackpipa",
  "saduk",
  "saenghwang",
  "salamuri",
  "salterio",
  "saluang",
  "samba whistle",
  "samica",
  "sampled performer",
  "sampler",
  "sampona",
  "samvadini",
  "sanfona",
  "sanger-in",
  "sansa",
  "sanshin",
  "santoor",
  "santur",
  "sanxian",
  "sanza",
  "sao meo",
  "sao truc",
  "sapeh",
  "sarangi",
  "saraswati veena",
  "sargija",
  "sarod",
  "saron",
  "saron barung",
  "saron demung",
  "saron family",
  "saron panerus",
  "saron peking",
  "saron wayang",
  "saroz",
  "sarrusophone",
  "satara",
  "satsuma",
  "satsuma biwa",
  "saw",
  "saw duang",
  "saw sam sai",
  "saw u",
  "saxello",
  "saxhorn",
  "saxophone",
  "saxophone quartet",
  "saxor",
  "saz",
  "scat",
  "schlagzeug drums",
  "schwyzerorgeli",
  "score",
  "score editor",
  "scottish small pipes",
  "scottish smallpipes",
  "scraped idiophone",
  "scraper",
  "scratcher",
  "scratches",
  "screen printing",
  "screenwriter",
  "script by",
  "segunda",
  "selmer-maccaferri guitar",
  "semi-acoustic guitar",
  "senh tien",
  "seni rebab",
  "seperewa",
  "sequenced by",
  "sequencer",
  "serpent",
  "set designer",
  "setar",
  "shahi baaja",
  "shaker",
  "shakers",
  "shakubyoshi",
  "shakuhachi",
  "shamisen",
  "shanai",
  "shavvm",
  "shawm",
  "shehnai",
  "shekere",
  "shenai",
  "sheng",
  "shichepshin",
  "shime-daiko",
  "shinobue",
  "sho",
  "shofar",
  "shouting",
  "shruti box",
  "shudraga",
  "shuitar",
  "shuttle pipes",
  "sign language interpreter",
  "sihu",
  "siku",
  "sil-snyan",
  "sindhi sarangi",
  "singer",
  "singing bowl",
  "singing bowls",
  "single reed",
  "sintir",
  "siren",
  "sistrum",
  "sitar",
  "sitar family",
  "skratjie",
  "slagbordun",
  "slapstick",
  "sleeve",
  "sleeve notes",
  "sleigh bells",
  "slentem",
  "slenthem",
  "slentho",
  "slide brass instruments",
  "slide guitar",
  "slide trumpet",
  "slide whistle",
  "slidetrumpet",
  "slit drum",
  "slit drums",
  "small bass violin",
  "small guitar",
  "smallpipes",
  "snare",
  "snare drum",
  "snare drums",
  "snaredrum",
  "sodina",
  "sodinar",
  "software instrument",
  "solo vocal",
  "soloist",
  "song loan",
  "songwriter",
  "sopilka",
  "sopranino",
  "sopranino clarinet",
  "sopranino recorder",
  "sopranino saxophone",
  "soprano",
  "soprano (voice)",
  "soprano clarinet",
  "soprano cornet",
  "soprano crumhorn",
  "soprano flute",
  "soprano recorder",
  "soprano sax (c)",
  "soprano saxophone",
  "soprano trombone",
  "soprano violin",
  "soprano vocals",
  "sordone",
  "sorna",
  "souna",
  "sound designer",
  "sound director",
  "sound effects",
  "sounds",
  "sousaphone",
  "souvliari",
  "spanish guitar",
  "speech",
  "spike-fiddle",
  "spilapipa",
  "spinet",
  "spinettone",
  "spoken word",
  "spoons",
  "square pianoforte",
  "stage manager",
  "steam locomotive sounds",
  "steel drum",
  "steel drums",
  "steel guitar",
  "steel-string acoustic guitar",
  "steelpan",
  "steirische harmonika",
  "step dancer",
  "stick sal",
  "stick zither",
  "stomp box",
  "storyteller",
  "street organ",
  "string drum",
  "string quartet",
  "string quintet",
  "string synthesizer",
  "string trio",
  "strings",
  "strings general",
  "stritch",
  "stroh violin",
  "strohfidel",
  "struck idiophone",
  "struck string instruments",
  "strumstick",
  "studio conductor",
  "studio personnel (performing)",
  "stylist",
  "stylophone",
  "subcontrabass recorder",
  "subcontrabass saxophone",
  "suka",
  "suling",
  "sung by",
  "suona",
  "supervised by",
  "surbahar",
  "surdo",
  "surdu",
  "surigane",
  "surmandal",
  "surnai (kashmir)",
  "sursingar",
  "svara mandala",
  "svirala",
  "swanee whistle",
  "swannee whistle",
  "swarmandal",
  "swarmandel",
  "symphony",
  "sympitar",
  "synclavier",
  "synth",
  "synthaxe",
  "synthesizer",
  "syrinx",
  "t'rung",
  "taal",
  "tabal",
  "tabla",
  "table steel guitar",
  "tabor",
  "tack piano",
  "taegum",
  "taepyeongso",
  "taepyungso",
  "taiko",
  "taishogoto",
  "talharpa",
  "talkbox",
  "talking drum",
  "tam tam",
  "tam-tam",
  "tama",
  "tambin",
  "tambora",
  "tamboril",
  "tamborim",
  "tambourine",
  "tambur (drum)",
  "tambur (gong)",
  "tambur (lute)",
  "tambura",
  "tambura (south east europe)",
  "tamburica",
  "tamburitza",
  "tamtam",
  "tan-tan",
  "tanbou ka",
  "tanbur",
  "tanbura",
  "tangent piano",
  "tannerin",
  "tanpura",
  "taonga puoro",
  "tap dance",
  "tap dancer",
  "tapan",
  "tapboard",
  "tape",
  "tape op",
  "taphon",
  "tar",
  "tar (drum)",
  "tar (flute)",
  "tar (frame drum)",
  "tar (lute)",
  "tar shenai",
  "taragoto",
  "tarawangsa",
  "tarka",
  "tarogato",
  "tarol",
  "tarota",
  "tavil",
  "te ku",
  "tea chest bass",
  "technician",
  "tef",
  "tefi",
  "telharmonium",
  "temple bells",
  "temple block",
  "temple blocks",
  "templeblocks",
  "temur khuur",
  "tenor",
  "tenor (voice)",
  "tenor banjo",
  "tenor bassoon",
  "tenor flute",
  "tenor guitar",
  "tenor horn",
  "tenor recorder",
  "tenor sarrusophone",
  "tenor saxophone",
  "tenor sordun",
  "tenor trombone",
  "tenor viol",
  "tenor violin",
  "tenor vocals",
  "tenora",
  "tenoroon",
  "tepsija",
  "text by",
  "thavil",
  "the great stalacpipe organ",
  "theatre organ",
  "theorbo",
  "theremin",
  "thon",
  "three-hole pipe",
  "throat singing",
  "thumb piano",
  "ti bwa",
  "ti-tse",
  "tibetan bowls",
  "tibetan singing bowl",
  "tibetan sin\u00adging bowl",
  "tibetan water drum",
  "tible",
  "tieu",
  "tifa",
  "timbal",
  "timbales",
  "timbrel",
  "timpani",
  "timple",
  "tin whistle",
  "tinya",
  "tiompan",
  "tiple",
  "tipple",
  "toasting",
  "tokere",
  "tololoche",
  "tom tom",
  "tom-tom",
  "tombak",
  "tonette",
  "tongatong",
  "tonkori",
  "topshuur",
  "torader",
  "totobuang",
  "toumbas",
  "tour manager",
  "tovshuur",
  "toy (instruments)",
  "toy piano",
  "tracking by",
  "traditional basque ensemble",
  "tram ple",
  "trang jau",
  "trang lu",
  "transcription by",
  "transferred by",
  "translated by",
  "transverse flute",
  "traps",
  "trautonium",
  "treble",
  "treble (voice)",
  "treble flute",
  "treble recorder",
  "treble shawm",
  "treble tambura",
  "treble viol",
  "treble violin",
  "treble vocals",
  "tres",
  "tres cubano",
  "triangle",
  "trikiti",
  "trikitixa",
  "triple harp",
  "tritantri veena",
  "tromba marina",
  "trombone",
  "trompeta",
  "trompeta china",
  "trong bong",
  "trumpet",
  "trumpet (eflat)",
  "trumpet family",
  "trutruka",
  "tsuur",
  "tuba",
  "tubaphone",
  "tubax",
  "tube zither",
  "tubon",
  "tubular bells",
  "tubulum",
  "tulum",
  "tumba",
  "tumba (goblet drum)",
  "tumbadora",
  "tumbi",
  "tumutumu",
  "tun",
  "tuned percussion",
  "tuned percussion general",
  "tunedpercussion",
  "tuner",
  "tungso",
  "tungur",
  "turntables",
  "tusseflute",
  "twelve-string guitar",
  "txalaparta",
  "txirula",
  "txistu",
  "tymps",
  "typewriter",
  "typography",
  "tzoura",
  "tzouras",
  "udu",
  "ugal",
  "uilleann pipes",
  "ukeke",
  "ukelele",
  "ukulele",
  "ukulele banjo",
  "unaccepted roles",
  "undefined (no usar)",
  "unidentified",
  "unidentified instruments",
  "unidentified payable contribution",
  "unidentified payable role",
  "unidentified string instument",
  "unnamed wind instrument",
  "unspecified drum",
  "untuned percussion",
  "upright piano",
  "utogardon",
  "valiha",
  "valve trombone",
  "valve trumpet",
  "valved brass instruments",
  "valvetrombone",
  "variophon",
  "veena",
  "vena",
  "venu",
  "vessel flute",
  "vibes",
  "vibra-slap",
  "vibrandoneon",
  "vibraphone",
  "vibraphono",
  "vibraslap",
  "vichitra veena",
  "vicitravina",
  "video editor",
  "vielle",
  "vielle (f)",
  "vietnamese guitar",
  "vihuela",
  "vina",
  "viol",
  "viol consort",
  "viol family",
  "viola",
  "viola (guitar)",
  "viola bastarda",
  "viola beiroa",
  "viola braguesa",
  "viola caipira",
  "viola campanica",
  "viola campani\u00e7a",
  "viola d'amore",
  "viola da gamba",
  "viola dagamba",
  "viola damore",
  "viola de cocho",
  "viola kontra",
  "viola nordestina",
  "viola organista",
  "viola pomposa",
  "violarina",
  "violin",
  "violin family",
  "violin octet",
  "violino piccolo",
  "viololyra",
  "violoncello",
  "violoncello piccolo",
  "violone",
  "violotta",
  "virginal",
  "virginals",
  "vocal",
  "vocal effects",
  "vocal percussion",
  "vocalese",
  "vocalizer",
  "vocals",
  "vocoder",
  "voice",
  "voice actor",
  "voice synthesizer",
  "vuvuzela",
  "wagner tuba",
  "walaycho",
  "waldhorn",
  "warr guitar",
  "washboard",
  "washint",
  "washtub bass",
  "waterphone",
  "wavedrum",
  "weisenborn",
  "whip",
  "whistle",
  "whistling",
  "whistling water jar",
  "wiener horn",
  "willow flute",
  "wind",
  "wind chime",
  "wind chimes",
  "wind general",
  "wind machine",
  "wind piano",
  "wind synthesizer",
  "wire-strung harp",
  "wobble board",
  "wood block",
  "wood chimes",
  "woodblock",
  "wooden fish",
  "wooden flute",
  "woodwind",
  "word director",
  "words by",
  "worship leader",
  "wot",
  "writer",
  "written by",
  "written-by",
  "wurlitzer electric piano",
  "wurlitzer organ",
  "xalam",
  "xaphoon",
  "xiao",
  "xiaoluo",
  "xilophono",
  "xun",
  "xylophone",
  "xylophone (strohfidel)",
  "xylorimba",
  "yaktaro",
  "yamaha wx-7",
  "yang t'chin",
  "yanggeum",
  "yangqin",
  "yatga",
  "yayli tanbur",
  "yehu",
  "yenjing",
  "yodel",
  "yodeling",
  "yonggo",
  "yoochin",
  "yorgaphone",
  "yueqin",
  "yunluo",
  "zabumba",
  "zafzafa",
  "zampogna",
  "zampona",
  "zamr",
  "zapateado",
  "zaqq",
  "zarb",
  "zeze",
  "zhaleika",
  "zhonghu",
  "zhongruan",
  "zhuihu",
  "zill",
  "zirbaghali",
  "zirbaghalia",
  "zither",
  "zongora",
  "zukra",
  "zumare",
  "zummara",
  "zurna",
];

/** Top-level parent roles only (the standardised role names). */
export const parentContributionRoles: string[] = [
  "12-string guitar",
  "accompanist",
  "accordion",
  "achere",
  "acoustic bass",
  "acoustic guitar",
  "akete",
  "alghoza",
  "algoja",
  "alphorn",
  "alto saxophone",
  "aman khuur",
  "analog synthesizer",
  "angklung",
  "anglo concertina",
  "appalachian dulcimer",
  "archlute",
  "arrabel",
  "arranger",
  "artist (unidentified)",
  "artistic narrator",
  "ashiko",
  "autoharp",
  "backing vocals",
  "baglama (saz) family",
  "bagpipe",
  "bagpipes",
  "baltic psalteries",
  "band",
  "bandoneon",
  "bandora",
  "banjo",
  "banjo guitar",
  "banjo-ukulele",
  "bansuri",
  "barbat",
  "baritone",
  "baritone (voice)",
  "baritone guitar",
  "baritone saxophone",
  "baroque guitar",
  "barrel drum",
  "barrel organ",
  "bass",
  "bass (voice)",
  "bass drum",
  "bass recorder",
  "bass viol",
  "bass violin",
  "bass-baritone",
  "bass-baritone (voice)",
  "bassoon",
  "bata drum",
  "bell",
  "bell-piano",
  "bellow-blown bagpipes",
  "bellowed reed",
  "bells",
  "bin",
  "bin-sitar",
  "biwa",
  "blue harp",
  "body percussion",
  "bombo",
  "bonang",
  "bonang barung",
  "bonang panembung",
  "bongos",
  "boobam",
  "border pipes",
  "bouzouki",
  "bowed lute",
  "bowed lyre",
  "bowed psaltery",
  "bowed string instruments",
  "box zither",
  "brass",
  "bronze lur",
  "bugle",
  "button accordion",
  "c-melody saxophone",
  "cabasa",
  "caixa",
  "caja",
  "cajon",
  "castanets",
  "castrato",
  "cavaquinho",
  "celesta",
  "cello",
  "chakhe",
  "chamber organ",
  "chamberlin",
  "chanting",
  "chap",
  "chapman stick",
  "chimes",
  "chirimia",
  "choir singer",
  "chorus",
  "chromatic button accordion",
  "chuurqin",
  "cither",
  "cittern",
  "clapper",
  "clapstick",
  "clarinet",
  "classical guitar",
  "clavichord",
  "claviorganum",
  "clog",
  "concert flute",
  "concert harp",
  "concertina",
  "conch",
  "concussion idiophone",
  "conductor",
  "congas",
  "contrabass saxophone",
  "contralto",
  "contralto (voice)",
  "contribution",
  "cornet",
  "cornett",
  "counter-tenor",
  "counter-tenor (voice)",
  "cowbell",
  "crumhorn",
  "cumbus",
  "curch organ",
  "cylindrical drum",
  "cymbal",
  "cymbals",
  "daf",
  "dan bau",
  "dan nhi",
  "dancer",
  "darbuka",
  "davul",
  "diatonic button accordion",
  "didgeridoo",
  "digital audio workstation",
  "dilli tuiduk",
  "dilruba",
  "disk drive",
  "dobro",
  "dohol",
  "dolceola",
  "double bass",
  "double flute",
  "double reed",
  "drum machine",
  "drum programming",
  "drums",
  "drums (drum set)",
  "dulce melos",
  "dulcian",
  "dulcimer",
  "dunun",
  "e-bass",
  "e-flat clarinet",
  "e-guitar",
  "ebow",
  "ektar",
  "ektara",
  "electric bass guitar",
  "electric cello",
  "electric fretless guitar",
  "electric guitar",
  "electric keyboards",
  "electric piano",
  "electric viola",
  "electric violin",
  "electronic drum set",
  "electronic instrument",
  "electronic organ",
  "electronic wind instrument",
  "elektronium",
  "eligible studio producer",
  "end-blown flute",
  "engineer",
  "euphonium",
  "ezzo-soprano",
  "falsetto",
  "falsetto (voice)",
  "fiddle",
  "fife",
  "finger cymbals",
  "finger snaps",
  "fipple flute",
  "five-string banjo",
  "flabiol",
  "flageolet",
  "flamenco guitar",
  "flugelhorn",
  "flumpet",
  "flute",
  "folk harp",
  "foot stomps",
  "frame drum",
  "free reed",
  "fretless bass",
  "friction drum",
  "friction idiophone",
  "frottoir",
  "frying-pan",
  "galo",
  "gamelan",
  "garifuna drum",
  "gayageum",
  "gender",
  "german concertina",
  "ghara",
  "glass",
  "glass harp",
  "goblet drum",
  "gong",
  "gong-chime",
  "gourd",
  "gralla",
  "grand piano",
  "great highland bagpipe",
  "guan",
  "guban",
  "gudok",
  "guitar",
  "guitaret",
  "guitarron chileno",
  "gumbri",
  "guqin",
  "gusli",
  "guzheng",
  "haegeum",
  "hammered dulcimer",
  "hammond organ",
  "hand clapping",
  "handbell",
  "handclaps",
  "harmonica",
  "harmonium",
  "harp",
  "harpsichord",
  "haute-contre",
  "hawaiian guitar",
  "helicon",
  "hi-hat",
  "hmong flute",
  "horn",
  "hoshu",
  "hourglass drum",
  "hunting horn (valved)",
  "huqin",
  "hurdy gurdy",
  "hurdy-gurdy",
  "idiophone",
  "interview",
  "jews harp",
  "jing",
  "jug",
  "kaba gaida",
  "kacapi",
  "kachva sitar",
  "kamanche",
  "kamancheh",
  "kannel",
  "karamouza",
  "karna (trumpet)",
  "kartal",
  "kaval",
  "kemenche",
  "kempul",
  "kendang",
  "kettle drum",
  "keyboards",
  "keyed box zither",
  "khol",
  "khong wong",
  "khong wong yai",
  "kkwaenggwari",
  "kkwaengwari",
  "klong that",
  "kora",
  "koto",
  "krap",
  "lakoto flute",
  "lamellaphone",
  "lamellophone",
  "lap steel guitar",
  "lira da braccio",
  "lirone",
  "literary director",
  "lithophone",
  "lukeme",
  "lute",
  "lute-harpsichord",
  "lyra viol",
  "lyre",
  "madal",
  "mandola",
  "mandolin",
  "mandolin family",
  "maracas",
  "marimba",
  "mbira",
  "melodica",
  "membranophone",
  "mendoza",
  "metallophone",
  "mezzo-contralto",
  "mezzo-soprano (voice)",
  "midi instrument",
  "mirliton",
  "miscellaneous",
  "monkey stick",
  "monochord",
  "morin khuur",
  "morsing",
  "mouth harp",
  "mouth organ",
  "mridangam",
  "murali",
  "musette de cour",
  "musical bow",
  "musical box",
  "nal (drum)",
  "nanga",
  "naqqara",
  "narrator",
  "natural brass instruments",
  "natural horn",
  "natural trumpet",
  "ngomi",
  "ngoni",
  "northumbrian pipes",
  "nose flute",
  "nyatiti",
  "nyckelharpa",
  "oboe",
  "oboe da caccia",
  "octavilla",
  "octoban",
  "orchestra",
  "organ",
  "other instruments",
  "other woodwind instruments",
  "pahu",
  "pakhawaj",
  "pan flute",
  "panpipe",
  "pardessus de viole",
  "pedal steel guitar",
  "percussion",
  "percussion idiophone",
  "performer",
  "pi",
  "pianet",
  "piano",
  "piano accordion",
  "pianoforte",
  "piccolo",
  "piccolo oboe",
  "pipa",
  "pipe",
  "pipe and tabor",
  "pipe organ",
  "piri",
  "plucked idiophone",
  "plucked string instruments",
  "pluriarc",
  "portuguese guitar",
  "positive (organ)",
  "post horn",
  "producer",
  "producer (vocal)",
  "programming",
  "psaltery",
  "pulankulal",
  "pump organ",
  "putatara",
  "qilaut",
  "quadruple reed",
  "quena",
  "quinto",
  "rababa",
  "racket",
  "rackett",
  "rainstick",
  "ranat ek",
  "rapper",
  "rattle",
  "ravanahatha",
  "rebab",
  "reco-reco",
  "recorder",
  "reeds",
  "regal",
  "remixer",
  "repinique",
  "resonator guitar",
  "rhythm sticks",
  "riq",
  "rondador",
  "rototom",
  "ruan",
  "rudra veena",
  "sabar",
  "saduk",
  "samica",
  "sanshin",
  "sanxian",
  "sarangi",
  "sargija",
  "saron",
  "saron family",
  "sarrusophone",
  "satsuma biwa",
  "saw duang",
  "saw u",
  "saxophone",
  "saz",
  "scottish smallpipes",
  "scraped idiophone",
  "scratcher",
  "shaker",
  "shakers",
  "shakuhachi",
  "shawm",
  "shekere",
  "siku",
  "singer",
  "singing bowl",
  "single reed",
  "sitar",
  "sitar family",
  "slenthem",
  "slide brass instruments",
  "slidetrumpet",
  "slit drum",
  "snare drum",
  "sodinar",
  "sopilka",
  "sopranino recorder",
  "sopranino saxophone",
  "soprano",
  "soprano (voice)",
  "soprano saxophone",
  "sorna",
  "sound director",
  "sound effects",
  "sounds",
  "souvliari",
  "spike-fiddle",
  "spilapipa",
  "spinet",
  "steel drums",
  "steel guitar",
  "steel-string acoustic guitar",
  "stick zither",
  "storyteller",
  "string drum",
  "string quartet",
  "string quintet",
  "strings",
  "struck idiophone",
  "struck string instruments",
  "surdo",
  "sursingar",
  "swannee whistle",
  "swarmandal",
  "synthesizer",
  "tack piano",
  "taepyeongso",
  "taiko",
  "taishogoto",
  "talharpa",
  "tamborim",
  "tambourine",
  "tambura",
  "tamburica",
  "tamtam",
  "tanbur",
  "taonga puoro",
  "tap dance",
  "tar",
  "tar (frame drum)",
  "tarota",
  "tef",
  "tefi",
  "temple blocks",
  "tenor",
  "tenor (voice)",
  "tenora",
  "tenoroon",
  "thavil",
  "theatre organ",
  "three-hole pipe",
  "tibetan sin\u00adging bowl",
  "tibetan water drum",
  "tifa",
  "timbales",
  "timple",
  "tin whistle",
  "tiple",
  "tom-tom",
  "topshuur",
  "toumbas",
  "toy piano",
  "trang lu",
  "treble",
  "treble (voice)",
  "tres",
  "trikiti",
  "tromba marina",
  "trombone",
  "trumpet",
  "trumpet family",
  "tuba",
  "tube zither",
  "tumba (goblet drum)",
  "tuned percussion",
  "tunedpercussion",
  "tungso",
  "tzoura",
  "uilleann pipes",
  "ukulele",
  "unaccepted roles",
  "unidentified instruments",
  "unidentified payable contribution",
  "utogardon",
  "valve trombone",
  "valved brass instruments",
  "veena",
  "vessel flute",
  "vibraphone",
  "vibraphono",
  "vibraslap",
  "vichitra veena",
  "vielle",
  "viol",
  "viol family",
  "viola",
  "viola da gamba",
  "violin",
  "violin family",
  "violin octet",
  "viololyra",
  "virginal",
  "vocal",
  "vocals",
  "voice",
  "walaycho",
  "washboard",
  "whistle",
  "wind",
  "wind chime",
  "wind general",
  "wind synthesizer",
  "wood block",
  "woodwind",
  "worship leader",
  "xalam",
  "xiao",
  "xiaoluo",
  "xylophone",
  "xylophone (strohfidel)",
  "yangqin",
  "yatga",
  "yodeling",
  "zarb",
  "zhuihu",
  "zirbaghali",
  "zither",
  "zummara",
];
